const SCREENS = {
  FORM: "FORM",
  SUCCESS: "SUCCESS",
};

export default SCREENS;
